import $ from 'jquery'
import WidgetView from '../widget-view'
import _ from 'lodash'
import TextWidgetConfig from './text-widget-config'
import Editor from 'scoreboard/components/rich-text/editor'
import template from './text-widget-view.hbs'
import Tooltip from 'scoreboard/components/tooltip'
import ScrollListener from 'scoreboard/components/scroll-listener'
import deviceType from 'scoreboard/components/device-type'
import i18n from 'scoreboard/components/i18n'
import KeyCodes from 'scoreboard/components/key-codes'
import WidgetControlView from '../widget-control-view'
import replacePlaceholders from 'scoreboard/templates/replace-placeholders'
import globals from 'scoreboard/components/globals'
import calendars from 'scoreboard/components/calendars'
import formatValue from 'scoreboard/components/format-value'
import { CURSOR_PLACEHOLDER } from 'scoreboard/components/rich-text/prepare-rich-text'
import togglePrefixedClass from 'scoreboard/components/toggle-prefixed-class'
import isSelectionInElement from 'scoreboard/components/is-selection-in-element'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

const VIEW = 'view'
const SELECTED = 'selected'
const EDIT = 'edit'

var TextWidgetControlView = WidgetControlView.extend({

	render: function () {
		WidgetControlView.prototype.render.apply(this, arguments)
		this.$el.addClass('text-widget-controls')
		// If user clicked on config button, switch back to VIEW mode
		this.$('.config-handle-settings').on('mousedown', () => {
			this.widgetView.state(VIEW)
		})
		return this
	},

	/**
	 * @override
	 */
	_startResize() {
		WidgetControlView.prototype._startResize.apply(this, arguments)
		this.widgetView.state(VIEW)
	},

	/**
	 * @override
	 */
	startRotate() {
		WidgetControlView.prototype.startRotate.apply(this, arguments)
		this.widgetView.state(VIEW)
	}
})

var TextWidgetView = WidgetView.extend({
	className: 'widget text-widget',
	resizable: true,
	autoResize: true,
	configClass: TextWidgetConfig,

	controlViewCls: TextWidgetControlView,

	nonFetchProperties: WidgetView.prototype.nonFetchProperties.concat('text'),

	initialize: function () {
		WidgetView.prototype.initialize.apply(this, arguments)

		this._scrollListener = new ScrollListener()
		_.bindAll(this, '_onOutsideClick', '_onWobSelect', '_onMouseDown', '_onTouchStart')

		this.listenTo(this.model.wob, 'change:left change:top', this._onWobMove.bind(this))
		this.listenTo(this.model.wob, 'change:locked', () => this.state(VIEW))
		this.listenTo(this.model.properties, 'change:background', this.adjustSize.bind(this))
	},

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		if (this.$('.content').length === 0) {
			this.$el.append(template({
				text: this.replacePlaceholders(this.model.richText())
			}))
			$(this.container)
				.on('selected', this._onWobSelect)
				.on('mousedown', this._onMouseDown)
				.on('touchstart', this._onTouchStart)

			this.state(VIEW)
		} else if (this.readonly) {
			// If we're on the dashboard Overview (this.readonly), and we're rendering
			// after the initial render, it's probably because of a period change; in that
			// case, redo the placeholder replacement with the current [calendar-period]
			this.$('.rich-text-content').html(this.replacePlaceholders(this.model.richText()))
		}

		this.readyForDisplayAndExport()

		this.on('config', () => this.state(VIEW))

		return this
	},

	_updateStateClass() {
		togglePrefixedClass(this.container, 'is-state', this.state())
	},

	state(state) {
		if (arguments.length === 0) {
			return this._state
		}

		this._state = state

		this._updateStateClass()

		if (state === VIEW) {
			this._renderViewOnly()
		} else if (state === SELECTED) {
			this._renderSelectAllEditor()
		} else if (state === EDIT) {
			this._renderEditor()
		}
	},

	_onMouseDown(e) {
		this._onPointerDown(e, 'mouseup')
	},

	_onTouchStart(e) {
		if (this.state() === VIEW) {
			// If we're in VIEW mode, let canvas do its thing
			return
		}

		this._onPointerDown(e, 'touchend')
	},

	_onPointerDown: function (e, pointerUpEventName) {
		if (this.readonly || this.model.wob.get('locked')) {
			return
		}
		let initialState = this.state()

		if (initialState === EDIT) {
			// if user was editing, we don't care about mousedown
			e.stopPropagation()
			return
		}

		// The user is either about to move the wob or just click on it.
		// To tell the difference, wait until the click is complete and see if the
		// wob was moved
		let moving = false
		let onMove = () => {
			moving = true
			this.$el.addClass('is-moving')
		}
		this.model.wob.once('change:left change:top', onMove)

		// Listen for the mouseup/touchend on canvas, because for some reason, we don't get events
		// on the padding of the wob. But if the mousedown/touchstart started on the wob, then we can
		// safely assume the next event that bubbles up to the canvas is what we want
		//
		// Note that we used to listen for 'click', but iOS 'click' events weren't being fired
		// properly. Instead, we listen for mouseup/touchend events.
		$(this.canvas.el).one(pointerUpEventName, () => {
			if (moving) {
				// if the user moved the wob, just transition to SELECTED state
				this.$el.removeClass('is-moving')
				this.state(SELECTED)
			} else {
				// The user didn't move the wob, so it was just a click.

				if (initialState === VIEW) {
					// If the state was VIEW before the click, we just transition to SELECTED
					this.state(SELECTED)
				} else if (initialState === SELECTED) {
					// If the state was SELECTED before the click, then we transition to EDIT

					// Try to determine where they clicked
					let range = null

					if (document.caretPositionFromPoint) {
						//firefox
						let pos = document.caretPositionFromPoint(e.clientX, e.clientY)
						range = document.createRange()
						range.setStart(pos.offsetNode, pos.offset)
						range.setEnd(pos.offsetNode, pos.offset)
					} else if (document.caretRangeFromPoint) {
						// safari + chrome + edge
						range = document.caretRangeFromPoint(e.clientX, e.clientY)
					}

					// if we have a range or the placeholder text is not there (no real content), so
					// the default behavior of placing the cursor at the beginning is fine
					if (range && !this.$('.text-widget-placeholder').length > 0) {
						// Insert a dummy DOM node before rendering the editor, and then we can focus
						// on that when the editor is loaded
						range.insertNode($(`<span class="${CURSOR_PLACEHOLDER}" style="display:none">|</span>`)[0])
					}

					this.state(EDIT)
				}
			}

			this.model.wob.off(null, onMove)
		})
	},

	_focusOnCursorPlaceholder() {
		let cursorNode = this.$('.' + CURSOR_PLACEHOLDER)[0]
		if (cursorNode) {
			let cursorContainer = cursorNode.parentElement
			let offset = Array.from(cursorContainer.childNodes).indexOf(cursorNode)

			if (offset < cursorContainer.childNodes.length - 1) {
				// if the cursor placeholder wasn't the last element of its parent, we can
				// just use its index as the offset
				this._editor.setCursor(cursorContainer, offset)
			} else {
				// if the cursor placeholder WAS the last element of its parent, then its index
				// will actually be out of bounds once we remove the placeholder.
				// Instead, stick the cursor at the end of the previous sibling
				let lastNode = cursorContainer.childNodes[cursorContainer.childNodes.length - 2]
				if (lastNode) {
					if (lastNode.nodeType === Node.TEXT_NODE) {
						this._editor.setCursor(lastNode, lastNode.length)
					} else {
						this._editor.setCursor(lastNode, lastNode.childNodes.length - 1)
					}
				} else {
					this._editor.setCursor(cursorContainer)
				}
			}
			$(cursorNode).remove()
		} else {
			this._editor.focus()
		}
	},

	/**
	 * Handles 'selected' events on the wob that were triggered by canvas
	 */
	_onWobSelect: function (e, selected) {
		// if selecting, _onMouseDown() will handle changing the state

		if (!selected) {
			// if unselecting, go back to VIEW mode
			this.state(VIEW)
		}
	},

	_onWobMove() {
		if (this.state() === SELECTED) {
			// if a SELECTED widget is being moved, switch to VIEW mode until
			// moving is done...
			this.state(VIEW)

			// then switch back to SELECTED mode
			$(this.container).one('click', () => this.state(SELECTED))
		}
	},

	_renderViewOnly() {
		// if going to VIEW mode, remove any editors. Don't need to worry about
		// updating the DOM node, because removing the editor leaves the DOM node intact
		this._removeEditor()
		this._removeSelectAllEditor()
		this._togglePlaceholderText(true)

		this._blockEdgeLinks()
	},

	_togglePlaceholderText(show) {
		let text = this.model.properties.get('text')

		// `show` is just a boolean indicating whether the placeholder should be shown if necessary.
		// Figure out if it's really necessary
		let actuallyShow
		if (!show) {
			actuallyShow = false
		} else if (text && text.trim().length > 0) {
			// if there's text already, don't show the placeholder
			actuallyShow = false
		} else if (this.readonly || this.model.wob.get('locked')) {
			// if the wob is readonly (dashboard Overview) or locked (either explicitly or because it's a template copy),
			// don't show placeholder text (because they can't actually "click to change"
			actuallyShow = false
		} else {
			actuallyShow = true
		}

		if (actuallyShow) {
			if (this.$('.rich-text-content .text-widget-placeholder').length === 0) {
				this.$('.rich-text-content').html(`<div class="text-widget-placeholder">${i18n.get('editor.clickToEdit')}</div>`)
			}
			this.$el.addClass('is-empty')
		} else {
			this.$('.rich-text-content .text-widget-placeholder').remove()
			this.$el.removeClass('is-empty')
		}
	},

	_blockEdgeLinks() {
		if (!deviceType.edge) {
			return
		}

		// #17981 "pointer-events: none" prevents the browser from acting on anchors
		// in the text in edit mode, but Edge doesn't honor that. Instead,
		// we need to clobber the relevant events

		if (!this.readonly) {
			this.$('.content a')
				// remove any previously added event handlers
				.off('dragstart.blockie')
				.off('click.blockie')
				.on('dragstart.blockie', (e) => {
					// prevent "dragging an anchor opens it in a new tab" behavior
					e.preventDefault()
				})
				.on('click.blockie', (e) => {
					// prevent click-and-drag from registering as a click on the anchor
					e.preventDefault()
				})
		}
	},

	_renderSelectAllEditor() {
		if (this._selectAllEditor) {
			return
		}

		if (this.readonly || this.model.wob.get('locked')) {
			return
		}

		this._removeEditor()

		// In SELECTED state, we can't render the "real" editor yet, or the contentEditable
		// will prevent the wob from being dragged.
		// Instead, create an fresh editor with a new DOM node, hide it from the user, and
		// apply all changes from the toolbar to that
		this._selectAllEditor = new Editor({
			text: this.$('.content .rich-text-content').html(),
			selectAllMode: true
		})

		this.listenToOnce(this._selectAllEditor, 'load', () => {
			if (!this._selectAllEditor) {
				return
			}

			// hide the editor and stick it in the DOM. Needs to be in the DOM for
			// selection to work.
			$(this._selectAllEditor.editor.getBody())
				.css({
					// Can't use 'visibility: hidden' or Safari won't allow the selection
					opacity: 0,
					// position it underneath the '.content .rich-text-content' div so it
					// doesn't interfere with clicks #17579
					position: 'absolute',
					top: 0,
					left: 0,
					'z-index': -1
				})
				.appendTo(this.el)

			this._selectAllEditor.selectAll()

			if (this.$('.text-widget-placeholder').length === 0) {
				// if the placeholder text is there, there's nothing to actually style,
				// so don't show the toolbar until they go to 'edit' mode
				this._renderToolbar(this._selectAllEditor)
			}

			this.listenTo(this._selectAllEditor, 'change', (val) => {
				this.model.properties.set('text', val)
				this.$('.content .rich-text-content').html(val)
				this.adjustSize()
			})

			this._selectAllEditor.editor.on('keydown', (e) => {
				if (e.keyCode == KeyCodes.DELETE || e.keyCode == KeyCodes.BACKSPACE) {
					// #15056 if DELETE key hit in "selected" mode, delete the wob
					// (instead of it functioning as a delete in the editor)
					this.model.wob.destroy()
					return
				}

				// #23044 when in "selected" mode, typing should be ignored; user
				// needs to click again to get to full "edit" mode
				e.preventDefault()
				e.stopPropagation()
			})

			// For the next two listeners, I'm using addEventListener so I can pass the flag to listen on
			// the "capture" phase. This makes sure that the contentEditable is destroyed
			// and allows the event gets to canvas's 'keybindings' listeners.

			// #19434 If the arrow keys are used while in SELECTED mode, it should move
			// the wob, and moves are done in VIEW mode.
			this._selectAllEditor.el.addEventListener('keydown', (e) => {
				if (_.includes(ARROW_KEYCODES, e.keyCode)) {
					this.state(VIEW)
				}
			}, true)

			// #19442 If a copy is done while in SELECTED mode, we're copying entire
			// widgets, not the text; switch to VIEW mode so we don't end up pasting into the editor
			this._selectAllEditor.el.addEventListener('copy', (e) => {
				this.state(VIEW)
			}, true)
		})

		this._selectAllEditor.render()

		this._blockEdgeLinks()
	},

	_renderEditor() {
		if (this._editor) {
			return
		}

		if (this.readonly || this.model.wob.get('locked')) {
			return
		}

		this._removeSelectAllEditor()
		this._togglePlaceholderText(false)

		this._editor = new Editor({ el: this.$('.rich-text-content')[0] })

		this.listenToOnce(this._editor, 'load', () => {
			this._focusOnCursorPlaceholder()

			$(document).on('click', this._onOutsideClick)

			this._renderToolbar(this._editor)

			this._scrollListener.on(this.el, () => {
				// Re-render the toolbar on scroll so that it still lines up.
				// #19441 Safari sometimes fires scroll events even though no scroll
				// appeared to happen. To guard against this, only re-render the
				// tooltip if the coordinates of the attachTo element changed
				if (this._tooltip && this._tooltip.attachedToMoved()) {
					this._renderToolbar(this._editor)
				}
			})

			this.listenTo(this._editor, 'change', (val) => {
				this._onEditorChange(val)
			})
		})

		this._editor.render()
	},

	_onEditorChange(val) {
		this.model.properties.set('text', val)
		this.adjustSize()
	},

	/**
	 * Returns the size of the widget contents so that the wob can be adjusted to
	 * fit them.
	 *
	 * @override WidgetView.getAdjustedSize()
	 */
	getAdjustedSize() {
		this.$el.addClass('is-adjusting-size')

		// Extra size-related variables
		var outlineWidth = this.model.wob.get('outlineWidth')
		var outlineWidthPx = _.isNil(outlineWidth) ? 0 : parseInt(outlineWidth)
		var richContent = this.$('.rich-text-content')[0]
		var padding = parseInt(this.$('.content').css('padding'))
		var height = this.el.offsetHeight

		// If there's an outline, add in the width of that outline to the padding
		if (outlineWidthPx > 0) {
			padding += outlineWidthPx
		}

		// If we're going from a non padding background state to a padded background
		// and we're not showing an empty wob, compensate for future padding (10px from text-widget.scss)
		if (!this.$el.hasClass('is-empty') && this.model.properties.attributes.background != 'none'
			&& padding == 0) {
			padding = 10
		}

		// Adjust the richContent based on how much future horizontal space it will
		// have (full width - .content padding - outline width)
		$(richContent).css('width', this.el.clientWidth - padding*2)

		// If the adusted richContent is poking out of the bottom of the wob,
		// compensate the wob height
		if (richContent.offsetHeight > height - padding*2) {
			height = richContent.offsetHeight + padding*2
		}

		$(richContent).removeAttr('style')
		this.$el.removeClass('is-adjusting-size')

		return {
			height,
			width: this.el.offsetWidth
		}
	},

	replacePlaceholders(text) {
		if (!this.readonly) {
			// If we're in edit mode, leave the placeholders alone
			return text
		}

		let period = calendars.periodsById[this.model.options.getPeriodId()]
		let calendar = period.calendar
		let dashboard = this.canvas.dashboard
		let org = this.model.data.organizations(
			dashboard.get('organizationId') ?? this.model.options.organizationId)

		return replacePlaceholders(text, [
			{ placeholder: 'calendar', value: calendar?.label },
			{ placeholder: 'calendar-period', value: period?.label },
			{ placeholder: 'dashboard', value: dashboard.get('label') },
			{ placeholder: 'organization', value: org?.label },
			{
				placeholder: 'today',
				value: formatValue({
					value: new Date(),
					dataType: DATE
				})
			}
		])
	},

	// Debouncing this method because we can end up with many scroll events being fired in succession
	_renderToolbar: _.debounce(function (editor) {
		if (this._tooltip && deviceType.safari && deviceType.isMobile()) {
			// When the iOS keyboard pops up, it fires off scroll events, which can cause some problems with our focus
			// listeners. Fortunately, the tooltip is still positioned properly, so we can just leave the toolbar around
			return
		}

		this._removeTooltip()

		var topOfWob = this.container.position().top
		var canvasScrollTop = this.$el.closest('.canvas-container').scrollTop()
		var topOfWobVisible = topOfWob > canvasScrollTop

		var placement = 'above'
		if (!topOfWobVisible) {
			// issue #10779
			// The top of the wob isn't visible on the canvas, but we can't rely on the normal
			// tooltip rotation logic, because the tooltip may still be visible on the screen
			// while the wob is covered by the dashboard header.
			// So we'll manually move the tooltip to the left.
			placement = 'left'
			var wobHeight = this.model.wob.get('height')

			// By default, the tooltip will be in the center of the wob, but even that may not
			// be visible on the canvas. This will shift the tooltip near the top of the canvas
			var adjustment = -1 * (topOfWob + (wobHeight / 2) - canvasScrollTop - 20)
		}

		editor = editor || this._editor

		this._toolbarView = editor.createToolbar()

		this._tooltip = new Tooltip({
			attachTo: this.el,
			attachToCenter: true,
			content: this._toolbarView,
			placement: placement,
			adjustment: adjustment,
			arrow: 'center',
			closeOnChangedFocus: false,
			closeOnAttachedToClick: false,
			extraClass: 'editor-toolbar'
		}).render()
	}, 250, { leading: true, maxWait: 500 }),

	/*
	* If the editor is visible, and they click outside, we need to destroy the editor
	*/
	_onOutsideClick: function (e) {
		if (!this._tooltip) {
			return
		}

		if (this.$el.find(e.target).length) {
			return
		}

		// If they click on the toolbar, that's okay
		if (isOrIn(this._tooltip.el, e.target)) {
			return
		}

		// #18234 if mouseup occurs on the tooltip, for some reason e.target === document
		// To handle that case, check what element is under the mouse, and if it's the
		// tooltip, no need to close it
		if (isOrIn(this._tooltip.el, elementUnderMouse(e))) {
			return
		}

		// If they clicked on the color picker tooltip, that's okay too
		if ($(e.target).closest('.color-picker-tooltip').length > 0) {
			return
		}

		// If the click was in the canvas, we can ignore it:
		//   - If user is selecting text and the mouseup occurred outside the widget,
		//     we don't want to kill the editor.
		//   - If it was a legit click in the canvas somewhere, canvas will take care of
		//     unselecting everything anyway.
		if (this.canvas.el.contains(e.target)) {
			return
		}

		if (isSelectionInElement(this.el)) { // #24896
			// Don't close if user is selecting text and mouseups outside the input
			return
		}

		if (this._toolbarView && this._toolbarView.linkTooltip
			&& isSelectionInElement(this._toolbarView.linkTooltip.el)) {

			// #24896 Don't close if user is selecting text and mouseups outside
			// the link input
			return
		}

		this._renderViewOnly()
	},

	_removeEditor: function () {
		if (this._editor) {
			// instead of editor.remove() (which destroys the DOM node with the text),
			// just detach it (kills all listeners and the tinymce editor)
			this.stopListening(this._editor)
			this._editor.detach()
			delete this._editor
		}

		this._removeTooltip()

		$(document).off('click touchstart', this._onOutsideClick)

		this._scrollListener.off()
	},

	_removeTooltip: function () {
		this._tooltip && this._tooltip.remove()
		delete this._tooltip
		// Don't need to call remove() on this._toolbarView, because the tooltip
		// code will take care of that. Just need to delete the reference
		delete this._toolbarView
	},

	_removeSelectAllEditor() {
		this._removeTooltip()

		this._selectAllEditor && this._selectAllEditor.remove()
		delete this._selectAllEditor
	},

	remove: function () {
		WidgetView.prototype.remove.apply(this, arguments)

		this._removeEditor()
		this._removeSelectAllEditor()
		$(this.container).off('selected', this._onWobSelect)
	}
})

/**
 * Returns true if elementToCheck is or is in the container
 */
function isOrIn(container, elementToCheck) {
	return $(container).find(elementToCheck).length || container === elementToCheck
}

function elementUnderMouse (e) {
	return document.elementFromPoint(e.clientX, e.clientY)
}

const ARROW_KEYCODES = [ KeyCodes.LEFT, KeyCodes.RIGHT, KeyCodes.UP, KeyCodes.DOWN ]

export default TextWidgetView

TextWidgetView.__filename__ = 'dashboards/widgets/text/text-widget-view.js'
